import { createAsyncThunk } from '@reduxjs/toolkit';

export const setFormNotesState = createAsyncThunk(
    'projectForm/setFormNotesState',
    async (note, { getState }) => {
        return { note };
    }
);